// extracted by mini-css-extract-plugin
export default {"main":"Base_main__nqXwx"};